
import * as React from "react";
import * as ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { SnackbarProvider } from 'notistack';
import Slide from '@material-ui/core/Slide';
import { AppContainer } from "react-hot-loader";
import Progress from "./components/Progress";
/* global document, Office, module */

// Lazy load the App component
const App = React.lazy(() => import("./components/App"));

// Error Boundary component to catch runtime errors
class ErrorBoundary extends React.Component {
    state = { hasError: false, error: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="text-center p-4">
                    <h2 className="text-red-600">Something went wrong</h2>
                    <p>Please try refreshing the add-in or contact support.</p>
                    {this.state.error && (
                        <p className="text-sm text-gray-600">Error: {this.state.error.message}</p>
                    )}
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

initializeIcons();

let isOfficeInitialized = false;

const title = "Promptr";

const render = (Component) => {
    ReactDOM.render(
        <SnackbarProvider
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            maxSnack={3}
            TransitionComponent={Slide}
        >
            <AppContainer>
                <React.Suspense
                    fallback={
                        <Progress
                            title={title}
                            logo={require("./../../assets/promptr.png")}
                            message="Loading Promptr..."
                        />
                    }
                >
                    <ErrorBoundary>
                        <Component title={title} isOfficeInitialized={isOfficeInitialized} />
                    </ErrorBoundary>
                </React.Suspense>
            </AppContainer>
        </SnackbarProvider>,
        document.getElementById("container")
    );
};

// Render application after Office initializes
Office.onReady()
    .then(() => {
        isOfficeInitialized = true;
        console.log("Office initialized successfully");
        // Handle tempo_token from URL
        if (window.location.href.includes("tempo_token")) {
            const params = new URLSearchParams(window.location.search);
            const tempoToken = params.get('tempo_token');
            if (tempoToken) {
                console.log('Tempo token set');
                sessionStorage.setItem('tempo_token', tempoToken);
            }
        }
        render(App);
    })
    .catch((error) => {
        console.error("Failed to initialize Office:", error);
        isOfficeInitialized = false;
        render(App); // Render with Progress fallback if Office fails
    });

// Hot reloading support
if (module.hot) {
    module.hot.accept("./components/App", () => {
        import("./components/App").then((module) => {
            const NextApp = React.lazy(() => import("./components/App"));
            render(NextApp);
        });
    });
}
